import { createAction, props } from '@ngrx/store';
import { DeviceData } from '../_models';

// Action types
export const loadDevicesData = createAction(
  '[DeviceData] Load DevicesData',
  props<{ deviceID: string; from: string; periodTo: string; limit: number; onlyImages: boolean }>()
);
export const loadDevicesDataSuccess = createAction(
  '[DeviceData] Load DevicesData Success',
  props<{ devicesData: DeviceData[] }>()
);
export const loadDevicesDataFailure = createAction(
  '[DeviceData] Load DevicesData Failure',
  props<{ error: any }>()
);
